import { reactive, watchEffect } from '@vue/composition-api';
import { createInjection } from '@/lib/createInjection';
import { JohaisetsuSagyouContext } from '@/components/Sp/Johaisetsu/types';

const { provide, inject } = createInjection<JohaisetsuSagyouContext>('johaisetsuSagyou/johaisetsuSagyouContext');

export function provideJohaisetsuSagyouContext(getContext: () => JohaisetsuSagyouContext): void {
  const context = reactive<JohaisetsuSagyouContext>(getContext());
  watchEffect(() => {
    const next = getContext();
    context.ability = next.ability;
    context.johaisetsuTypeGroup = next.johaisetsuTypeGroup;
    context.johaisetsuTypeGroupName = next.johaisetsuTypeGroupName;
    context.sagyouActionLabel = next.sagyouActionLabel;
    context.inProgressReport = next.inProgressReport;
  });
  provide(context);
}

export function useJohaisetsuSagyouContext(): JohaisetsuSagyouContext {
  return inject();
}
